<script lang="ts">
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import type { IconType } from "$components/+blocks/OVIcon/OVIcon";

  export let href: string;
  export let icon: IconType;
</script>

<a
  {href}
  target="_blank"
  rel="noopener noreferrer"
  class="text-xs font-medium text-neutral-400 transition-colors hover:text-neutral-600 dark:hover:text-neutral-300"
>
  <OVIcon {icon} />
</a>
